import { isSupportedPaidBreakDuration } from "./restBreaks";

const PAID_BREAK_DURATION_HOURS = 10 / 60;
export const normalizePaidBreaks = (paidBreaks = []) =>
  (paidBreaks || []).map((paidBreak) => ({
    ...paidBreak,
    break_duration: paidBreak.break_duration || PAID_BREAK_DURATION_HOURS,
  })).sort((a, b) => a.break_start - b.break_start);

export const validatePaidBreaks = (shift, enabled = true) => {
  if (!enabled) {
    return { valid: true, message: "" };
  }

  const paidBreaks = normalizePaidBreaks(shift?.paid_breaks);
  if (!paidBreaks || paidBreaks.length === 0) {
    return { valid: true, message: "" };
  }

  const shiftStart = shift.shift_start;
  const shiftEnd = shift.shift_end;
  let previousEnd = shiftStart;

  for (let i = 0; i < paidBreaks.length; i++) {
    const breakStart = paidBreaks[i].break_start;
    const duration =
      paidBreaks[i].break_duration || PAID_BREAK_DURATION_HOURS;
    const breakEnd = breakStart + duration;

    if (!Number.isFinite(breakStart)) {
      return { valid: false, message: "Paid break start times must be set." };
    }

    if (!isSupportedPaidBreakDuration(duration)) {
      return { valid: false, message: "Paid breaks must be 10 or 15 minutes." };
    }

    if (breakStart < shiftStart || breakEnd > shiftEnd) {
      return {
        valid: false,
        message: "Paid breaks must fall within the shift window.",
      };
    }

    if (breakStart < previousEnd) {
      return {
        valid: false,
        message: "Paid breaks must be ordered and non-overlapping.",
      };
    }

    const unpaidBreaks = [
      {
        break_start: shift.break_start,
        break_length: shift.break_length,
      },
      {
        break_start: shift.break_start_2,
        break_length: shift.break_length_2,
      },
    ].filter(
      (breakEntry) =>
        typeof breakEntry.break_start === "number" &&
        (breakEntry.break_length || 0) > 0
    );

    if (
      unpaidBreaks.some((breakEntry) => {
        const unpaidBreakStart = breakEntry.break_start;
        const unpaidBreakEnd = breakEntry.break_start + breakEntry.break_length;
        return breakStart < unpaidBreakEnd && breakEnd > unpaidBreakStart;
      })
    ) {
      return {
        valid: false,
        message: "Paid breaks cannot overlap with unpaid breaks.",
      };
    }

    previousEnd = breakEnd;
  }

  return { valid: true, message: "" };
};

